import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Step, Icon } from 'semantic-ui-react';
import { get } from 'lodash';

import { Filter } from 'Containers/';
import { errorToast } from 'Common/ToastHelper';
import { clearErrors, getData } from './state/powerschool/actions';
import IntegrationPreview from 'Components/SISIntegrations/IntegrationPreview';
import { SISIntegrations } from 'Common/Constants/Enumeration/IntegrationsEnum';
import { getGrades, getSites } from 'State/selectors';
import { getLanguages } from 'Pages/importstudents/state/selectors';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { makeOptionsData, makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import PowerSchoolConfiguration from './components/PowerSchoolConfiguration';
import PowerSchoolBulkImport from './components/PowerSchoolBulkImport';
import { SISFieldEnum } from 'Common/Constants/SISIntegration';

export class PowerSchoolIntegrationContainer extends Component {
  componentDidUpdate(prevProps, prevState) {
    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearErrors();
    }
  }

  componentDidMount() {
    this.props.getData();
  }

  teacherOptions = () =>
    makeOptionsData([
      { Id: 1, Description: 'grade_level' },
      { Id: 2, Description: 'expression' },
      { Id: 3, Description: 'termid' },
    ]);

  StepsEnum = {
    configure: 1,
    preview: 2,
    import: 3,
  };

  state = {
    activeStep: this.StepsEnum.configure,
    completedSteps: [],
  };

  steps = [
    {
      key: this.StepsEnum.configure,
      title: 'Configuration',
      description: 'Configure the integration and mappings.',
      icon: 'configure',
      onSubmit: values => {},
      disabled: () => false,
    },
    {
      key: this.StepsEnum.preview,
      title: 'Preview',
      description: 'Confirm the data is mapped correctly.',
      icon: 'info',
      disabled: () =>
        !this.state.completedSteps.some(c => c === this.StepsEnum.configure),
    },
    {
      key: this.StepsEnum.import,
      title: 'Manual Import',
      description: 'Import your data.',
      icon: 'file text',
      disabled: () =>
        ![this.StepsEnum.configure, this.StepsEnum.preview].every(i =>
          this.state.completedSteps.some(c => c === i)
        ),
    },
  ];

  stepComplete = () => {
    const { activeStep, completedSteps } = this.state;

    if (!completedSteps.some(s => s === activeStep)) {
      this.setState({ completedSteps: [...completedSteps, activeStep] });
    }
  };

  nextStep = () => {
    const { activeStep } = this.state;

    this.stepComplete();

    if (activeStep === Object.values(this.StepsEnum).pop()) {
      return;
    }

    this.setState({ activeStep: activeStep + 1 });
  };

  prevStep = () => {
    const { activeStep } = this.state;

    if (activeStep === Object.values(this.StepsEnum).shift()) {
      return;
    }

    this.setState({ activeStep: activeStep - 1 });
  };

  render() {
    const {
      fetching,
      configuration,
      gradeOptions,
      siteOptions,
      languageOptions,
    } = this.props;
    const { activeStep, completedSteps } = this.state;

    return (
      <Fragment>
        {fetching && <LoadingPage />}
        <Filter title={'PowerSchool Integration'} newRow>
          <Step.Group widths={3}>
            {this.steps.map(step => (
              <Step
                completed={completedSteps.some(c => c === step.key)}
                active={activeStep === step.key}
                disabled={step.disabled()}
                key={step.key}
                onClick={() => {
                  this.setState({ activeStep: step.key });
                }}
              >
                <Icon name={step.icon} />
                <Step.Content>
                  <Step.Title>{step.title}</Step.Title>
                  <Step.Description>{step.description}</Step.Description>
                </Step.Content>
              </Step>
            ))}
          </Step.Group>
        </Filter>
        {!fetching && (
          <Fragment>
            {activeStep === this.StepsEnum.configure && (
              <PowerSchoolConfiguration
                stepComplete={this.stepComplete}
                isComplete={completedSteps.some(
                  c => c === this.StepsEnum.configure
                )}
                nextStep={this.nextStep}
                configuration={configuration}
                gradeOptions={gradeOptions}
                siteOptions={siteOptions}
                languageOptions={languageOptions}
                teacherOptions={this.teacherOptions()}
              />
            )}
            {activeStep === this.StepsEnum.preview && (
              <IntegrationPreview
                integrationName={SISIntegrations.POWER_SCHOOL}
                stepComplete={this.stepComplete}
                isComplete={completedSteps.some(
                  c => c === this.StepsEnum.preview
                )}
                nextStep={this.nextStep}
                prevStep={this.prevStep}
                gradeOptions={gradeOptions}
                siteOptions={siteOptions}
                languageOptions={languageOptions}
              />
            )}
            {activeStep === this.StepsEnum.import && (
              <PowerSchoolBulkImport
                stepComplete={this.stepComplete}
                HasManualBeenRunNotes={get(
                  configuration,
                  SISFieldEnum.HasManualBeenRunNotes,
                  ''
                )}
                isComplete={completedSteps.some(
                  c => c === this.StepsEnum.import
                )}
                prevStep={this.prevStep}
              />
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  clearErrors,
  getData,
};

const mapStateToProps = state => {
  const { PowerSchoolIntegration } = state.PowerSchoolIntegrationState;
  return {
    error: PowerSchoolIntegration.error,
    fetching: PowerSchoolIntegration.fetching,
    loading: PowerSchoolIntegration.loading,
    configuration: PowerSchoolIntegration.configuration,
    gradeOptions: makeOptionsData(getGrades(state),{
      keyKey: 'Id',
      valueKey: 'Id',
      textKeys: ['Id', 'Description'],
    }),
    siteOptions: makeOptionsDataRemoveEmpty(
      getSites(state).filter(s => s.IsActive && s.IsLicensed),
      true
    ),
    languageOptions: makeOptionsData(getLanguages(state)),
  };
};

export const PowerSchoolIntegration = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PowerSchoolIntegrationContainer)
);



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/PowerSchoolIntegration.js